<template>
  <modal :show="show" @close="close" title="Free ticket" :subtitle="`Send a free ticket for this ${type}`" class="no-overflow">
    <div class="p-a-4">
      <p class="card-content-title">Ticket</p>
      <form-dropdown placeholder="Choose ticket" class="site-style semi" @input="selectedTicket = $event.value" :items="tickets" />
      <p v-if="selectedTicket !== null && !newExpiration" class="m-t-1">
        <span class="link blue" @click="newExpiration = true">Set another expiration date?</span>
      </p>
      <template v-if="newExpiration">
        <p class="card-content-title m-t-1" >New expiration date -<span class="blue hover" @click="newExpiration = false">Hide</span></p>
        <form-input type="date" v-model="expiration" />
      </template>
      <p class="card-content-title m-t-2">E-mail</p>
      <form-input type="text" v-model="email"  />
      <p class="card-content-title m-t-2">Send receipt?</p>
      <FormCheckbox class="large" :selected="receipt" icon="check" @input="handleReceipt" />
    </div>
    <template v-slot:footer>
      <div class="d-f f-w">
        <Button :class="`${state === 'success' ? 'green' : ''}`" :disabled="!isSendable || ['sending', 'success'].includes(state)" @click="sendTicket">
          <template v-if="state === 'sending'">Sending ticket</template>
          <template v-else-if="state === 'success'">Ticket sent!</template>
          <template v-else>Send ticket</template>
        </Button>
        <Button class="red outline ml-a" @click="close">Cancel</Button>
      </div>
    </template>
  </modal>
</template>

<script>

import moment from 'moment';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'broadcast',
      validator: value => ['broadcast', 'video'].indexOf(value) !== -1,
    },
  },
  computed: {
    /**
     * Return a boolean if the ticket is sendable
     * @returns {Boolean}
     */
    isSendable() {
      if (this.newExpiration && !this.expiration) {
        return false;
      }

      return this.selectedTicket !== null && this.email !== '';
    },
    item() {
      if (this.type === 'video') {
        return this.$store.getters['Video/current'];
      }

      return this.$store.getters['Broadcast/current'];
    },
    /**
     * Return list of tickets that broadcast has
     */
    tickets() {
      const {
        item: {
          id,
        },
      } = this;

      // eslint-disable-next-line
      return this.$store.getters['Products/allStreams'].filter(ticket => ticket.access.content.includes(this.type === 'video' ? 'video:*' : 'live:*') || ticket.access.content.includes(this.type === 'video' ? `video:${id}` : `live:${id}`) ? ticket : null).map(ticket => ({ value: ticket.id, string: ticket.name, description: ticket.description, selected: ticket.id === this.selectedTicket }));
    },
  },
  methods: {
    handleReceipt() {
      this.receipt = !this.receipt;
    },
    async sendTicket() {
      clearTimeout(this.sentTimeout);

      const {
        selectedTicket,
        item: {
          id,
          metadata: {
            title,
          },
        },
        fqdn,
        newExpiration,
        expiration,
        email,
        receipt,
      } = this;

      const payload = {
        product_id: selectedTicket,
        access: {
          content: this.type === 'video' ? `video:${id}` : `live:${id}`,
        },
        email: {
          to: email,
          not_sending: !receipt,
        },
        metadata: {
          title: `You have been given free access to ${title}`,
          url: `https://${fqdn}.streamify.io/play/broadcast/${id}`,
        },
      };

      if (newExpiration && expiration) {
        payload.access.expire_at = new Date(expiration);
      }

      this.state = 'sending';

      try {
        await ovpFetch('/vouchers', {
          method: 'POST',
          body: JSON.stringify(payload),
        });
      } catch (e) {
        swal({ title: 'An error occured', text: 'For some reason we could not send this ticket right now', icon: 'error' });
        this.state = '';
        return;
      }

      this.state = 'success';

      this.sentTimeout = setTimeout(() => {
        this.email = '';
        this.state = '';
      }, 2000);
    },
    close() {
      this.selectedTicket = null;
      this.email = '';
      this.state = '';
      this.$emit('close', true);
    },
  },
  data() {
    return {
      receipt: true,
      selectedTicket: null,
      newExpiration: false,
      expiration: null,
      email: '',
      state: '',
      minDate: moment().format('Y-MM-DD'),
      sentTimeout: null,
    };
  },
  beforeDestroy() {
    clearTimeout(this.sentTimeout);
  },
};
</script>

<style lang="scss" scoped>
.broadcast-free-ticket {
  display: flex;
  flex-direction: column;
  height: 100%;

  p {
    font-size: 15px;
    line-height: 32px;
  }
}
</style>
